export default __webpack_public_path__ + "static/media/IMG_5571.f7f5c242.jpg";